import React from 'react';

import partnerPropTypes from '../partnerPropTypes';

const ReviewLink = ({ partner }) => {
    if (!partner.reviewUrl) {
        return <span />;
    }

    return (
        <div>
            <p className="mln">Hvordan var det å handle med {partner.name}?</p>

            <div className="r-mts">
                <a href={partner.reviewUrl}>
                    Gi en vurdering av {partner.name}
                </a>
            </div>
        </div>
    );
};

ReviewLink.propTypes = {
    partner: partnerPropTypes.isRequired,
};

export default ReviewLink;



// WEBPACK FOOTER //
// ./safeTrade/review/reviewLink.jsx